import getMFEConfig from 'helpers/getMFEConfig'
import useNavigateOnRedirect from 'hooks/useNavigateOnRedirect'
import Promotions from 'promotions-mfe'
import { useAtomValue } from 'jotai'
import { selectedAccountAtom } from 'store/atoms'

const PromotionsPage = () => {
  const promotionsMfeConfig = getMFEConfig('mma')
  const selectedAccount = useAtomValue(selectedAccountAtom)

  useNavigateOnRedirect()
  return (
    <Promotions
      config={promotionsMfeConfig}
      accountId={selectedAccount}
      accountIdType="guid"
    />
  )
}
export default PromotionsPage
